/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceDetailRequest {
    getFixupPrototypeFunction() { return InfraResourceDetailRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceDetailRequest>): InfraResourceDetailRequest {
        let obj = Object.assign(new InfraResourceDetailRequest(), model);
        InfraResourceDetailRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceDetailRequest>): InfraResourceDetailRequest {
        if (!model) return null;
        return InfraResourceDetailRequest.newInstance(<InfraResourceDetailRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceDetailRequest) {
        if (!obj) return;

        models.InfraResourceDetailRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceDetailRequest): boolean {
        Object.setPrototypeOf(obj, InfraResourceDetailRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID. Can be fetched from the List Tenants API.
     */
    tenant_id: string;

    /**
     * Unique provider resource identifier.
     */
    resource_id: string;

    /**
     * Cloud account ID to scope the lookup.
     */
    service_account_id: string;

    /**
     * Category of the resource (e.g. Compute, Storage, Network).
     */
    resource_category: string;

    /**
     * Type of the resource.
     */
    resource_type: string;

    /**
     * Resources of the cloud provider (e.g. Instances, SecurityGroups).
     */
    resource: string;

}
